import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import StaffAppSplash from './StaffAppSplash';

export default function StaffAppProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return <StaffAppSplash />;
  if (!user) return <Navigate to="/staff-app/login" replace />;
  return children;
}
